import { AccessPolicy } from '@chr/online-shared-microsite-core/types';

export enum UserAccessPoliciesActionTypes {
  USER_ACCESS_POLICIES_INIT = 'USER_ACCESS_POLICIES_INIT',
  USER_ACCESS_POLICIES_SET = 'USER_ACCESS_POLICIES_SET',
  USER_ACCESS_POLICIES_RETRIEVAL_FAILED = 'USER_ACCESS_POLICIES_RETRIEVAL_FAILED',
}

// Action Creators
export const getUserAccessPolicies = () => ({
  type: UserAccessPoliciesActionTypes.USER_ACCESS_POLICIES_INIT,
  payload: {},
});

export const setUserAccessPolicies = (accessPolicies: AccessPolicy[]) => ({
  type: UserAccessPoliciesActionTypes.USER_ACCESS_POLICIES_SET,
  payload: accessPolicies,
});

export const userAccessPoliciesRetrievalFailed = (error: any) => ({
  type: UserAccessPoliciesActionTypes.USER_ACCESS_POLICIES_RETRIEVAL_FAILED,
  payload: error,
  error: true,
});
